import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import LoadingData from "../Common/LoadingData";
import Footer from "../Footer/Footer";
import "./../styles/accomplishments.css";



const accomplishContainer = {
  hidden: {
    opacity: 0,
    x: "100vh",
  },
  visible: {
    opacity: 1,
    x: "0",
    transition: {
      type: "spring",
      stiffness: 120,
    },
  },
  hov: {
    scale: 1.05,
  },
};

const Accomplishments = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/myprofile`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        setData(data.msg);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return loading ? (
    <div style={{ width: "", textAlign: "center", marginTop: "300px" }}>
      <div className="lds-dual-ring"></div>
    </div>
  ) : (
    <div className="accomplishments">
      <div className="container container-custom-accomplishment">
        <motion.div
          className="results-container"
          variants={accomplishContainer}
          initial="hidden"
          animate="visible"
        >
          <h1>
            Quizzes <span>results</span>
          </h1>

          {!data.quizzes.length > 0 ? (
            <LoadingData />
          ) : (
            <div className="results-content">
              <div className="results-top">
                <div>
                  <h2>Quizzes</h2>
                </div>
                <div>
                  <h2>Date</h2>
                </div>
                <div>
                  <h2>Score</h2>
                </div>
              </div>
              <hr />
              {data?.quizzes?.map((item, index) => (
                <div key={index} className="results-bottom">
                  <div>
                    <h2>{item.name}</h2>
                  </div>
                  <div>
                    <h2>{item?.date?.substring(0, 10)}</h2>
                  </div>
                  <div>
                    <h2>{item.score}/5</h2>
                  </div>
                </div>
              ))}
            </div>
          )}
        </motion.div>

        <>
          <Footer />
        </>
      </div>
    </div>
  );
};

export default Accomplishments;
